enum ErrorFlow {
  register = 'register', // page was enter username or otc
  login = 'login', // page was login
  resetPassword = 'reset-password', // page was reset pw, user hit reset password from manual reg or forgot password
  registerResetPassword = 'register-reset-password', // page was reset pw, user hit reset password during register flow
  callCentreResetPassword = 'call-centre-reset-password', // page was reset pw, user came from call centre reset password
  forgotEmail = 'forgot-email',
  manualReg = 'manual-reg', // new manual reg flow
  profileChangePassword = 'change-password',
}

export { ErrorFlow };
